<template>
  <div>
    <h5 class="mb-3">Services (lignes de réparation)</h5>
    <form @submit.prevent="saveService(repairService)">
      <div class="row align-items-end">
        <div class="col-xl-5 col-12 my-3">
          <label for="serviceSelect"
            >Service <span class="text-danger">*</span></label
          >
          <vue-select
            :options="services"
            v-model="repairService.service_reference"
            placeholder="Choisir un service"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Quantité</label>
          <input
            v-model.number="repairService.quantity"
            type="number"
            step="0.01"
            min="0.01"
            class="form-control"
          />
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for=""
            >Prix TTC <span class="text-danger">*</span></label
          >
          <input
            required
            v-model="repairService.priceTTC"
            type="number"
            step="0.01"
            min="0"
            class="form-control"
          />
        </div>

        <div class="col-xl-3 col-12 my-3">
          <label for="">Remarque</label>
          <input
            v-model="repairService.remark"
            class="form-control"
            placeholder="Optionnel"
          />
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-auto">
          <button class="btn btn-success shadow" type="submit">
            <i class="bi bi-plus-circle"></i> Insérer
          </button>
        </div>
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>

    <table class="table table-striped table-hover mt-3">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Qté</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">Total TTC</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(service, index) in repairServices" :key="service.id || index">
          <td>{{ index + 1 }}</td>
          <td>
            <span v-if="service.service">
              {{ service.service.fullName }}
            </span>
          </td>
          <td>{{ service.quantity != null ? service.quantity : 1 }}</td>
          <td>
            <span v-if="service.priceTTC != null">{{ service.priceTTC }}</span>
          </td>
          <td>
            <span v-if="service.totalPriceTTC != null">{{
              service.totalPriceTTC
            }}</span>
          </td>
          <td>{{ service.remark }}</td>
          <td>
            <button
              type="button"
              @click="removeRepairService(service)"
              class="btn text-danger"
            >
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <hr />
    <div class="row justify-content-between">
      <div class="col-xl col-12 d-flex flex-wrap gap-2 mb-2">
        <div>
          <span class="text-muted">Articles — éléments :</span>
          <span
            v-if="numberItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded ms-1"
            >{{ numberItems }}</span
          >
        </div>
        <div>
          <span class="text-muted">Services — lignes :</span>
          <span class="fw-bold bg-info px-2 py-1 rounded ms-1">{{
            repairServices.length
          }}</span>
        </div>
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Quantité totale (articles) :</div>
        <div class="col">
          <span
            v-if="totalQuantityItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalQuantityItems }}
          </span>
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Quantité (services) :</div>
        <div class="col">
          <span class="fw-bold bg-info px-2 py-1 rounded">{{
            repairServicesQty
          }}</span>
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Montant articles (TTC) :</div>
        <div class="col">
          <span
            v-if="totalPriceTTCItems != ''"
            class="fw-bold bg-warning px-2 py-1 rounded"
          >
            {{ totalPriceTTCItems }}
          </span>
          DH
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto">Montant services (TTC) :</div>
        <div class="col">
          <span class="fw-bold bg-info px-2 py-1 rounded">{{
            repairServicesTTC.toFixed(2)
          }}</span>
          DH
        </div>
      </div>

      <div class="col-xl col-12 d-flex">
        <div class="col-auto fw-bold">Total TTC (global) :</div>
        <div class="col">
          <span class="fw-bold bg-success text-white px-2 py-1 rounded">{{
            grandTotalTTC.toFixed(2)
          }}</span>
          DH
        </div>
      </div>
    </div>
    <hr />
    <br />
    <div class="row">
      <div
        class="col-xl-3 col-md-4 col-6 my-3"
        :class="{
          'pe-none user-select-none opacity-75': !!repair.customer_reference,
        }"
      >
        <label for="repairCustomerSelect"
          >Client <span class="text-danger">*</span></label
        >
        <vue-select
          id="repairCustomerSelect"
          :options="customersForSelect"
          v-model="repair.customer_reference"
          placeholder="Choisir un client"
          labelColumn="displayName"
          valueColumn="reference"
        />
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="repair.date" class="form-control" />
      </div>

      <!-- <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Vehicle <span class="text-danger">*</span> </label>
        <select
          v-model="repair.vehicle_reference"
          :disabled="repair.vehicle_reference ? true : false"
          class="form-select"
        >
          <option value="--">--</option>
          <option
            v-for="(vehicle, index) in vehicles"
            :key="index++"
            :value="vehicle.reference"
          >
            {{ vehicle.registrationPlate }} {{ vehicle.manufacturerName }}
            {{ vehicle.modelName }}
          </option>
        </select>
      </div>

     
       <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for="">
          Réception a
          <span class="text-danger">*</span></label
        >
        <input
          type="datetime-local"
          v-model="repair.receptionDatetime"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for="">
          Livraison prévue a <span class="text-danger">*</span></label
        >
        <input
          type="date"
          v-model="repair.scheduledDeliveryDateTime"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Code Moteur </label>
        <select v-model="repair.engineCode" class="form-select">
          <option :value="true">Oui</option>
          <option :value="false">Non</option>
        </select>
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Code de demarrage </label>
        <input type="text" v-model="repair.startingCode" class="form-control" />
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Antivol de roues </label>
        <select v-model="repair.wheelLocks" class="form-select">
          <option :value="true">Oui</option>
          <option :value="false">Non</option>
        </select>
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Niveau de carburant </label>
        <select v-model="repair.fuelLevel" class="form-select">
          <option value="1/4">1/4</option>
          <option value="1/2">1/2</option>
          <option value="3/4">3/4</option>
          <option value="P">P</option>
        </select>
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> Validite de controle technique </label>
        <input
          type="date"
          v-model="repair.technicalInspectionValidity"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-md-4 col-6 my-3">
        <label for=""> KM </label>
        <input type="text" v-model="repair.mileage" class="form-control" />
      </div>

      <div class="row">
        <div class="col-3 my-3">
          <label for=""> Pneumatiques AVD </label>
          <input
            type="text"
            v-model="repair.frontRightTireCondition"
            class="form-control"
            placeholder="%"
          />
        </div>

        <div class="col-3 my-3">
          <label for=""> Pneumatiques AVG </label>
          <input
            type="text"
            v-model="repair.frontLeftTireCondition"
            class="form-control"
            placeholder="%"
          />
        </div>

        <div class="col-3 my-3">
          <label for=""> Pneumatiques ARD </label>
          <input
            type="text"
            v-model="repair.rearRightTireCondition"
            class="form-control"
            placeholder="%"
          />
        </div>

        <div class="col-3 my-3">
          <label for=""> Pneumatiques ARG </label>
          <input
            type="text"
            v-model="repair.rearLeftTireCondition"
            class="form-control"
            placeholder="%"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 col-md-4 col-6 my-3">
          <label for=""> Pare-Brise Fêlure </label>
          <select v-model="repair.windshieldCrack" class="form-select">
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-4 col-6 my-3">
          <label for=""> Pare-Brise Cassure </label>
          <select v-model="repair.windshieldBroken" class="form-select">
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-4 col-6 my-3">
          <label for=""> Pare-Brise Éclat </label>
          <select v-model="repair.windshieldChipped" class="form-select">
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 col-md-6 col-6 my-3">
          <label for=""> Phare D </label>
          <select
            v-model="repair.rightHeadlightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-6 col-6 my-3">
          <label for=""> Phare G </label>
          <select
            v-model="repair.leftHeadlightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 col-md-3 col-6 my-3">
          <label for=""> Feux AVD </label>
          <select
            v-model="repair.frontRightLightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-3 col-6 my-3">
          <label for=""> Fexu AVG </label>
          <select
            v-model="repair.frontLeftLightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-3 col-6 my-3">
          <label for=""> Feux ARD </label>
          <select
            v-model="repair.rearRightLightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>

        <div class="col-xl-3 col-md-3 col-6 my-3">
          <label for=""> Feux ARG </label>
          <select
            v-model="repair.rearLeftLightFunctionality"
            class="form-select"
          >
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
          </select>
        </div>
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Télécharger des photos </label>
        <input
          type="file"
          id="fileInput"
          ref="fileInput"
          name="fileInput"
          accept="image/*"
          multiple
          @change="handleImagesUpload"
          class="form-control"
        />
      </div>

      <div class="row align-items-stretch">
        <div
          v-for="(preview, index) in imagePreviews"
          :key="index"
          class="col-xl-3 col-md-3 col-6 px-xl-2 py-xl-3"
        >
          <div class="card rounded-0 h-100">
            <img :src="preview" alt="Image Preview" class="w-100" />
          </div>
        </div>
      </div> -->

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque <span class="text-danger">*</span></label>
        <textarea
          type="date"
          v-model="repair.remark"
          class="form-control"
        ></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">
        <div class="form-check align-items-center">
          <input
            type="checkbox"
            id="accept"
            value=""
            :checked="accept ? true : false"
            class="form-check-input me-2"
            @click="accept ? (accept = false) : (accept = true)"
          />
          <label class="form-check-label" for="accept">
            J'accepte que les informations (client, véhicule, services, articles,
            quantités, montants) sont correctes.
            <span class="text-danger">*</span>
          </label>
        </div>
      </div>
      <div class="col-xl-auto col-12">
        <button
          class="btn btn-success"
          @click="save(repair)"
          :disabled="!accept ? true : false"
        >
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-12 col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSelect from "@/components/cards/VueSelect.vue";

export default {
  components: { VueSelect },
  data() {
    return {
      repair: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        amountPaid: 0.0,
        customer_reference:
          this.$route.query.customer_reference != null
            ? String(this.$route.query.customer_reference)
            : "",
        remark: "",
      },
      repairService: {
        quantity: 1,
        priceTTC: "",
        remark: "",
        service_reference: "",
      },
      accept: false,
      photos: [],
      imagePreviews: [],
    };
  },
  computed: {
    ...mapGetters("repair", {
      repair_items: "getItems",
      repairServices: "getServices",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
      errors: "getErrors",
    }),

    ...mapGetters("service", {
      services: "getAll",
    }),

    ...mapGetters("customer", {
      customers: "getAll",
    }),

    customersForSelect() {
      return (this.customers || []).map((c) => ({
        reference: c.reference,
        displayName:
          [c.fullName, c.society].filter(Boolean).join(" ").trim() ||
          c.reference ||
          "",
      }));
    },

    ...mapGetters("vehicle", {
      vehicles: "getAll",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),

    repairServicesTTC() {
      return this.repairServices.reduce((acc, s) => {
        const t = parseFloat(s.totalPriceTTC);
        if (!Number.isNaN(t)) return acc + t;
        const q = parseFloat(s.quantity) || 1;
        const p = parseFloat(s.priceTTC) || 0;
        return acc + q * p;
      }, 0);
    },

    repairServicesQty() {
      return this.repairServices.reduce(
        (acc, s) => acc + (parseFloat(s.quantity) || 1),
        0
      );
    },

    grandTotalTTC() {
      const itemsTtc = parseFloat(this.totalPriceTTCItems) || 0;
      return itemsTtc + this.repairServicesTTC;
    },
  },
  watch: {
    "repairService.service_reference"(reference) {
      if (reference && this.services.length) {
        const service = this.services.find((s) => s.reference === reference);
        if (
          service &&
          service.priceTTC != null &&
          service.priceTTC !== "" &&
          !this.repairService.priceTTC
        ) {
          this.repairService.priceTTC = service.priceTTC;
        }
      }
    },
  },
  methods: {
    async saveService(data) {
      if (!data.service_reference) {
        this.$store.dispatch(
          "notification/store",
          { status: "error", message: "Veuillez sélectionner un service." },
          { root: true }
        );
        return;
      }
      const payload = {
        service_reference: data.service_reference,
        priceTTC: data.priceTTC,
        quantity: data.quantity != null && data.quantity !== "" ? data.quantity : 1,
        remark: data.remark,
      };
      await this.$store.dispatch("repair/storeService", payload);
      this.repairService = {
        quantity: 1,
        priceTTC: "",
        remark: "",
        service_reference: "",
      };
      await this.$store.dispatch("service/getAll");
    },

    async removeRepairService(row) {
      const label = row.service ? row.service.fullName : "cette ligne";
      await this.$confirm({
        message: "Voulez-vous supprimer : " + label + " ?",
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm && row.id) {
            this.$store.dispatch("repair/destroyService", row.id);
          }
        },
      });
    },

    async save(data) {
      var customerRef = data && data.customer_reference;
      if (
        customerRef === undefined ||
        customerRef === null ||
        customerRef === ""
      ) {
        this.$store.dispatch(
          "notification/store",
          {
            status: "error",
            message: "Choisissez un client.",
          },
          { root: true }
        );
        return;
      }
      await this.savePhotos();
      await this.$store.dispatch("repair/store", data);
      await setTimeout(((this.repair = {}), (this.accept = false)), 2000);
    },
    async refresh() {
      await this.$store.dispatch("repair/getAllItems");
      await this.$store.dispatch("repair/getAllServices");
      await this.$store.dispatch("service/getAll");
      await this.$store.dispatch("employee/getAll");
      await this.$store.dispatch("customer/getAll");
      await this.$store.dispatch("vehicle/getAll");
    },
    async handleImagesUpload(event) {
      const files = event.target.files;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.photos.push(file);

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    async savePhotos() {
      if (!this.photos || !this.photos.length) {
        return;
      }
      const formData = new FormData();
      for (let i = 0; i < this.photos.length; i++) {
        formData.append("photos[]", this.photos[i]);
      }
      await this.$store.dispatch("repair/storePhotos", formData);
    },
  },
  async beforeMount() {
    await this.$store.dispatch("repair/getAllItems");
    await this.$store.dispatch("repair/getAllServices");
    await this.$store.dispatch("service/getAll");
    await this.$store.dispatch("customer/getAll");
    await this.$store.dispatch("vehicle/getAll");
    this.$store.dispatch("employee/getAll");
  },
};
</script>
